<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary" id="list">
      <template slot="header">
        <i class='fa fa-align-justify'></i> User Pattern
      </template>

      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Created_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_group">Status</label>
              <br>
              <!-- <v-select v-model="so.opt['is_del']" :options="codes.is_del_text"></v-select> -->
              <select v-model="so.opt['is_del']" @change="refresh">
                <option disabled value="">Please select Enable or disable</option>
                <option value="false">Enable</option>
                <option value="true">Disable</option>
              </select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_type">Type</label>
              <br>
              <v-select v-model="so.opt['type']" :options="codes.WMDS_TYPE_text"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_level">Level</label>
              <br>
              <v-select v-model="so.opt['level']" :options="codes.WMDS_TYPE_text"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="9">
            <b-form-group>
              <label for="opt_code">Code</label>
              <br>
              <b-form-input v-model="so.opt['code']" @keyup.enter="refresh"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <label for="ph_search_opt_type">Group Name</label>
            <b-button variant="primary" @click="chainGroup = true">Select Group</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{model.enable + model.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{model.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{model.disable}}
          </b-badge>
        </b-col>
        <b-col :sm="view_detail !== false ? 10 : 12" class="md-10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='is_del';so.skt='Status'; so.sv = '';">Status</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='level';so.skt='Level'; so.sv = '';">Level</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='type';so.skt='Type'; so.sv = '';">Type</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='code';so.skt='Code'; so.sv = '';">Code</b-dropdown-item>
              </b-dropdown>

              <v-select :disabled="so.adv" v-if="so.sk == 'level'" @change="refresh" v-model="so.sv" :readonly="true" :options="codes.WMDS_TYPE_text"></v-select>
              <v-select :disabled="so.adv" v-if="so.sk == 'type'" @change="refresh" v-model="so.sv" :readonly="true" :options="codes.WMDS_TYPE_text"></v-select>
              <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'is_del'" @change="refresh">
                <option disabled value="">Please select Enable or disable</option>
                <option value="false">Enable</option>
                <option value="true">Disable</option>
              </select>

            </b-input-group-prepend>

            <b-form-input v-if="so.sk == 'code' || so.sk == ''" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>

            <div class="px-4">
              <b-badge variant="info">
                String : {{model.S}}
              </b-badge>
              <b-badge variant="primary">
                MD5 : {{model.M}}
              </b-badge>
              <b-badge variant="info">
                URL : {{model.U}}
              </b-badge>
              <b-badge variant="primary">
                Regex : {{model.R}}
              </b-badge>
            </div>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list"
        show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="group" slot-scope="row">{{row.item.group.groupname }}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date }}</template>
        <template slot="is_alive" slot-scope="row">
          <b-badge v-if="row.item.is_del" :variant="row.item.is_del ? 'danger' : 'success'"> Deleted </b-badge>
          <span v-else>
            <b-badge variant="success" v-if="row.item.is_alive">Enable</b-badge>
            <b-badge v-else variant="secondary">Disable</b-badge>
          </span>

        </template>
        <template slot="level" slot-scope="row"> {{codes.WMDS_TYPE[row.item.level] }} </template>
        <!-- type 은 꼭 있어야 함 -->
        <template slot="type" slot-scope="row">{{codes.WMDS_TYPE[row.item.type]}}</template>
        <template slot="code" slot-scope="row">
          <strong @click="detail(row.item)" style="cursor: pointer;" class="font-targeting">
            {{row.item.code | truncate(50) }}
          </strong>
        </template>
        <!-- <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">
            {{(model && model.id == row.item.id ? 'Selected' : 'Select')}}
          </b-btn>
        </template> -->
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
  </div>
</template>
<script>
import { Api } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';
import * as _ from 'lodash';
import groupList from '../../Management/group/Group.List'

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

export default {
  components: { DatePicker, cSwitch, vSelect, groupList },
  name : "userPattern",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => ({
    group_name : '',
    chainGroup : false,
    custom,
    codes,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0, S : 0, U : 0, R : 0, M : 0 },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
        { key: 'group', label: 'Group', sortable: true, thStyle: 'width: 12%' },
        { key: 'created_at', label: 'Registed_at', sortable: true, thStyle: 'width: 12%' },
        { key: 'is_alive', label: 'Status', sortable: true, thStyle: 'width: 12%' },
        { key: 'level', label: 'Level', sortable: true, thStyle: 'width: 12%' },
        { key: 'type', label: 'Type', sortable: true, thStyle: 'width: 12%' },
        { key: 'code', label: 'Code', sortable: true },
        // { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
      ]
    }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_del'] = '';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(['group_id'].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      } else if(k == 'type') {
        return { name : k, value : `${(v.substring(0, 1) || '').toUpperCase()}`, op : '=' }
      } else if(k == 'level') {
        if(v == 'danger') { return { name : k, value : 'H', op : '=' } }
        else if(v == 'caution') { return { name : k, value : 'N', op : '=' } }
        else { return { name : k, value : `${(v.substring(0, 1) || '').toUpperCase()}`, op : '=' } }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let and = []
      let so = {
        target : 'wmds.user.pattern', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : and
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      // if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if( this.so.sv && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
      if(this.partner) { so.body.and.push({ name : "partner_id", Value : this.partner.id, op : "=" }) }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    summary() {
      let and = [];
      Api.Manager({ target : 'wmds.user.pattern', cmd : 'summary', body : { and : and, or : [], sort : [] } })
        .then(rs => { this.model = Object.assign(this.model, rs.body) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      if(this.view_detail == false) { this.$emit("select", item); }
      else {
        this.$router.push({ name : 'wmds_upattern', params : { id : item.id } });
      }
    },
    add: async function() {
      try {

        let rs = await Api.Manager_Call('wmds.user.pattern', this.model.id ? 'update' : 'insert', this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name); this.list();
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
  },
  created() { console.log('wmds.user.pattern.list.vue', 'created'); },
  destroyed() { console.log('wmds.user.pattern.list.vue', 'destroyed'); },
  mounted() { console.log('wmds.user.pattern.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
